"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormSelectFacade", {
    enumerable: true,
    get: function() {
        return FormSelectFacade;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _useInputBorderCss = require("../useInputBorderCss");
const _useDropdownChevronBackground = require("../../../hooks/useDropdownChevronBackground");
const _contexts = require("../../../contexts");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormSelectFacade = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { disabled = false, className = "", children, ...props } = param;
    const theme = (0, _contexts.useTheme)();
    var _props_showChrome;
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        showChrome: (_props_showChrome = props.showChrome) !== null && _props_showChrome !== void 0 ? _props_showChrome : "onInteraction"
    });
    const dropdownBg = (0, _useDropdownChevronBackground.useDropdownChevronBackground)({
        color: theme.colors.grayscale[100]
    });
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ref: ref,
        ...props,
        className: _style.default.dynamic([
            [
                "926a8cbea64d272",
                [
                    theme.spacers.s3,
                    disabled ? "0.5" : "1",
                    disabled ? "not-allowed" : "pointer",
                    disabled ? theme.colors.grayscale[5] : theme.colors.white,
                    props.showChrome === true ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none",
                    dropdownBg
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "triggerInput ".concat(borderCss.className, " ").concat(className))
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "926a8cbea64d272",
        dynamic: [
            theme.spacers.s3,
            disabled ? "0.5" : "1",
            disabled ? "not-allowed" : "pointer",
            disabled ? theme.colors.grayscale[5] : theme.colors.white,
            props.showChrome === true ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none",
            dropdownBg
        ]
    }, ".triggerInput.__jsx-style-dynamic-selector{padding:".concat(theme.spacers.s3, ";opacity:").concat(disabled ? "0.5" : "1", ";cursor:").concat(disabled ? "not-allowed" : "pointer", ";background-color:").concat(disabled ? theme.colors.grayscale[5] : theme.colors.white, "!important;background:").concat(props.showChrome === true ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none", "}.triggerInput.__jsx-style-dynamic-selector:hover,.triggerInput.__jsx-style-dynamic-selector:focus,.focus-in.__jsx-style-dynamic-selector{background:").concat(dropdownBg, " right 11px center/16px 16px no-repeat}")));
});
FormSelectFacade.displayName = "FormSelectFacade";

//# sourceMappingURL=FormSelectFacade.js.map